import React from "react";
import { m, AnimatePresence } from "framer-motion";
import { useNetworkStatus } from "../../hooks/useNetworkStatus";
import { BiWifiOff } from "react-icons/bi";

/**
 * Banner de conectividade que aparece quando o usuário está offline.
 * Segue a estética Midnight (Ciano/Preto) da Daneluci Performance.
 */
export function ConnectivityBanner() {
  const isOnline = useNetworkStatus();

  return (
    <AnimatePresence>
      {!isOnline && (
        <m.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className="relative z-[9999] overflow-hidden bg-brand-cyan text-black shadow-lg"
        >
          <div className="flex items-center justify-center gap-3 px-4 py-2">
            <BiWifiOff className="size-5 animate-pulse" />
            <p className="text-xs font-black uppercase tracking-widest md:text-sm">
              Você está navegando em modo offline
            </p>
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
}
